module.exports = __webpack_public_path__ + "static/img/城市规划馆.c4461c87.png";